import { snakify } from '../helpers/common';
import { factory } from './base';

export interface Currency {
  code: string;
  symbol: string;
  subunitsToUnit: number;
  fiat: boolean;
  subcurrencies: {
    code: string;
    symbol: string;
    subunitsToUnit: number;
  }[];
}

export interface Country {
  name: string;
  code: string;
}

export const countries = factory(
  (r) => () => r<Country[]>('get', 'info/countries')
);

export interface PlayerFields {
  contexts: { [key: string]: string[] };
  fields: {
    field: string;
    type: string;
    length?: {
      minimum?: number;
      maximum?: number;
    };
    onceSet?: boolean;
    age?: any;
    inclusion?: any;
    service?: string;
  }[];
}

export const playerFields = factory(
  (r) => (playerState?: string) =>
    r<PlayerFields>(
      'get',
      `info/player_fields${playerState ? `?player_country=${playerState}` : ''}`,
      undefined,
      { headers: { 'X-Content-Policy': '3' } }
    )
);

interface Locale {
  code: string;
  default: boolean;
  name: string;
  nameInLocale: string;
}

export const pushStag = factory(
  (r) => (params: object) => r<Locale[]>('get', 'info/project', params)
);

export interface CurrentIp {
  countryCode: string;
  ip: string;
  regionCode: string;
}

export const currentIp = factory((r) => () => r<string>('get', 'current_ip'));

interface ResponseLocale {
  locale: string;
}

export const updateLocale = factory(
  (r) => (params: ResponseLocale) =>
    r<ResponseLocale>('patch', 'player/update_locale', snakify(params))
);
